import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

export const FAQAccordion = ({ items }) => {
  const [open, setOpen] = useState(0);
  return (
    <div className="max-w-3xl mx-auto divide-y divide-[var(--line)]" data-testid="faq-accordion">
      {items.map((f, i) => (
        <Reveal key={i} delay={i * 0.04}>
          <button onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-item-${i}`} className="w-full text-left py-6 flex items-start gap-4 group">
            <span className={`mt-1 shrink-0 transition-transform duration-300 ${open === i ? "rotate-45 text-accent" : "text-[var(--grey-soft)]"}`}><Plus size={22} /></span>
            <div className="flex-1">
              <h3 className={`font-display text-lg md:text-xl font-medium transition-colors ${open === i ? "text-accent" : "text-[var(--primary)] group-hover:text-accent"}`}>{f.q}</h3>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35 }} className="overflow-hidden">
                    <p className="pt-3 text-[var(--muted)] leading-relaxed">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </button>
        </Reveal>
      ))}
    </div>
  );
};
